module.exports = __webpack_public_path__ + "media/images/horses/Standlee-Hay-Company-Premium-Alfalfa-Pellet.png";